import type React from "react";

import icon from "~/components/ui/icons/svg/default-image.svg";

interface DefaultImageProps {
  width?: number | string;
  height?: number | string;
}

const DefaultImage: React.FC<DefaultImageProps> = ({
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      width={width}
      height={height}
      role="img"
      aria-label="Default product image placeholder"
    >
      <use xlinkHref={`#${icon}`} />
    </svg>
  );
};

export default DefaultImage;
